<template>
<div class="container-base">
  <div class="pages setting">
    <h1>데이터・계정삭제</h1>
    <p>{{ $site.name }}는 아래의 데이터를 삭제 할 수 있습니다.</p>
    <ul>
      <li>브라우저 저장데이터</li>
      <li>서버 백업데이터</li>
      <li>등록계정</li>
    </ul>
    <p>※삭제한 계정은 원래대로 되돌릴 수 없으므로 주의해 주십시오.</p>

    <div class="setting-item">
      <h2>1.브라우저 저장데이터 삭제</h2>
      <p>브러우저에 저장된{{ $site.name }}의 데이터를 삭제합니다.</p>
      <p>PC방 공용 PC에 사용한 경우 데이터를 삭제 해주시기 바랍니다.</p>
      <p>삭제한 데이터는 복원 할 수 없습니다.필요한 경우 미리 백업해 주시기 바랍니다.</p>
      <div class="delete-confirm text-right"
        v-if="!clearLocalStorageConfirmVisible">
        <el-button @click="clearLocalStorageConfirmVisible = true"
          type="danger"><i class="el-icon-delete"></i>브라우저 저장데이터 삭제</el-button>
      </div>
      <div class="delete-confirm text-right"
        v-else>
        <div style="text-align: right; margin: 0">
          <el-button @click="clearLocalStorageConfirmVisible = false">취소</el-button>
          <el-button @click="clearLocalStorage();"
            type="danger"><i class="el-icon-delete"></i>삭제</el-button>
          <p>삭제한 데이터는 복원 할 수 없습니다.</p>
        </div>
      </div>
    </div>

    <div v-if="$firebase.isAuthenticated" class="setting-item">
      <h2>2.서버 백업데이터 삭제</h2>
      <div v-if="backupList.length">
        <p>로그인 계정：{{ $firebase.user.email }}</p>
        <p>{{ backupList.length }}건의 백업이 있습니다.</p>
        <div v-if="backupList.length >= 100">
          한번에 삭제 할 수 있는 건수는 100건 입니다.
        </div>
        <div class="delete-confirm text-right"
          v-if="!deleteBackupsConfirmVisible">
          <el-button @click="deleteBackupsConfirmVisible = true"
            type="danger"><i class="el-icon-delete"></i> {{ backupList.length }}건도 백업 삭제</el-button>
        </div>
        <div class="delete-confirm"
          v-else>
          <div style="text-align: right; margin: 0">
            <el-button @click="deleteBackupsConfirmVisible = false">취소</el-button>
            <el-button @click="deleteBackups();"
              type="danger"><i class="el-icon-delete"></i>삭제</el-button>
              <p>삭제한 데이터는 복원 할 수 없습니다.</p>
          </div>
        </div>
      </div>
      <div v-else-if="backupListLoaded">
        <p>백업이 없습니다.</p>
      </div>

      <div class="setting-item">
        <h2>3.계정삭제</h2>
        <div v-if="backupList.length">
          <p>계정삭제를 하기전에 "2.서버 백업데이터 삭제"를 먼저 실행 해주세요.</p>
        </div>
        <div v-else-if="backupListLoaded">
          <div class="delete-confirm text-right"
            v-if="!deleteUserConfirmVisible">
            <el-button @click="deleteUserConfirmVisible = true"
              type="danger"><i class="el-icon-delete"></i> {{ $firebase.user.email }} 의 계정삭제</el-button>
          </div>
          <div class="delete-confirm"
            v-else>
            <div style="text-align: right; margin: 0">
              <el-button @click="deleteUserConfirmVisible = false">취소</el-button>
              <el-button @click="deleteUser();"
                type="danger"><i class="el-icon-delete"></i> 삭제</el-button>
                <p>삭제한 계정은 복원 할 수 없습니다.</p>
            </div>
          </div>
          <div v-if="deleteUserFailed" class="delete-error">
            <p>로그인 정보가 오래되었을 경우 계정삭제를 실패 할 수 있습니다.</p>
            <p>이경우에는 로그아웃 한뒤 다시 로그인하여 계정삭제를 해주세요.</p>
            <div class="text-right">
              <el-button id="google-logout-account-dialog"
              @click="$firebase.signOut();$event.preventDefault()">로그아웃</el-button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else class="not-authenticated setting-item">
      <div class="action">
        <p>서버데이터 삭제,계정삭제는 로그인이 필수 입니다.</p>
        <login-forms />
      </div>
    </div>
  </div>
</div>
</template>
<style lang="scss" src="@/assets/scss/pages/pages.scss"></style>
<style lang="scss" src="@/assets/scss/pages/setting.scss"></style>
<script>
import LoginForms from '@/components/LoginForms'
export default {
  components: {
    'login-forms': LoginForms
  },
  data: function () {
    return {
      deleteBackupsConfirmVisible: false,
      deleteUserConfirmVisible: false,
      deleteUserFailed: null,
      backupListLoaded: false,
      backupList: [],
      backupCount: 0,
      clearLocalStorageConfirmVisible: false
    }
  },
  methods: {
    clearLocalStorage: async function () {
      await this.$clearStorage()
      this.clearLocalStorageConfirmVisible = false
      const length = await this.$lengthOfStorage()
      if (length === 0) {
        this.$message({
          message: '브라우저 저장데이터를 삭제 하였습니다.',
          type: 'success'
        })
      } else {
        this.$message({
          message: '브라우저 저장데이터 삭제를 실패 하였습니다.:' + length,
          type: 'error'
        })
      }
    },
    loadAllBackupList: async function () {
      if (!this.$firebase.isAuthenticated) {
        return
      }
      const app = this
      app.backupListLoaded = false
      app.backupList = []
      await app.$firebase.getBackupList(null, 100)
        .then(function (querySnapshot) {
          querySnapshot.forEach(function (doc) {
            const data = doc.data()
            app.backupList.push({
              id: doc.id,
              label: data.label,
              timestamp: data.timestamp,
              type: data.type,
              platform: data.platform
            })
          })
          app.backupListLoaded = true
        })
        .catch(function (err) {
          console.error(err)
        })
    },
    deleteBackups: async function () {
      try {
        for (const backup of this.backupList) {
          console.log(backup.id)
          await this.$firebase.deleteBackup(backup.id)
        }
      } catch (e) {
        console.error(e)
      }
      this.loadAllBackupList()
    },
    deleteUser: async function () {
      await this.$firebase.user.reload()
      await this.loadAllBackupList()
      await this.deleteBackups()
      const formData = new FormData()
      formData.append('uuid', this.$firebase.user.uid)
      const deleteResult = this.$firebase.deleteUser()
      const app = this
      deleteResult.then(function () {
        app.$message({
          message: '계정을 삭제 하였습니다. 그동안 이용 해주셔서 감사합니다.',
          type: 'success'
        })
        app.$axios
          .post(app.$varuna.endPoints.deleteUser, formData)
        app.deleteUserConfirmVisible = false
        app.deleteUserFailed = false
        app.$firebase.signOut()
        app.$router.push('/login')
      }).catch(function (error) {
        app.$message({
          message: '계정삭제를 실패 하였습니다.',
          type: 'error'
        })
        app.deleteUserFailed = true
        console.error(error)
      })
    }
  },
  beforeMount: function () {
    this.$eventHub.$on('firebase-initialized', this.loadAllBackupList)
    this.loadAllBackupList()
  },
  destroyed: function () {
    this.$eventHub.$off('firebase-initialized', this.loadAllBackupList)
  }
}
</script>
